module.exports = __webpack_public_path__ + "static/media/icon-push-cart.68d0943b.svg";